export const opacityWhileDragging = 0.7;
